import React, { Component } from "react";
import HomeContent from "../FunctionComponents/HomeFolder/HomeContent.jsx";
import HallofFame from "../FunctionComponents/HallofFame/HallofFame.jsx";

class HallofFamePage extends Component {
  render() {
    return (
      <div>
        <HallofFame />
      </div>
    );
  }
}

export default HallofFamePage;
